import * as React from "react";
import { forwardRef } from "react";
const SvgBackArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 17, viewBox: "0 0 10 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.27148 16L1.17533 8.90385C1.12014 8.85205 1.07615 8.78949 1.04609 8.72003C1.01602 8.65057 1.0005 8.57569 1.0005 8.5C1.0005 8.42431 1.01602 8.34943 1.04609 8.27997C1.07616 8.21051 1.12014 8.14795 1.17533 8.09615L8.27149 1", stroke: "currentColor", strokeWidth: 1.71429, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgBackArrow);
export { ForwardRef as ReactComponent };
